<template>
  <div>
    <div class="ad">
      <a
        :href="
          'https://www.wch.cn/products/' +
          post.alias +
          '.html?from=signature_ad'
        "
        >热门产品 : {{ post.shortTitle }}</a
      >
    </div>
  </div>
</template>

<script>
import { getAd } from "@/service/post";

export default {
  data() {
    return {
      post: null,
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      getAd()
        .then((response) => {
          console.debug("response", response);
          if (response.code === 0) {
            this.post = response.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.ad {
  margin: 20px;
  margin-top: 10px;
  padding-top: 5px;
  border-top: 1px solid #969696;
  min-height: 40px;
  height: auto !important;
  font-size: 12px;
  margin-bottom: 20px;
}
</style>
